import Vue from 'vue'
import Vuex from 'vuex'
import {listSimpleDictDatas} from "../api/page";
import {getInstrumentList} from "../api/page";
import inspection from './modules/inspection'
import maintenance  from './modules/maintenance'
import dailycheck from './modules/dailycheck'
import user from './modules/user'
import patrol from './modules/patrol'
import eva from './modules/eva'
Vue.use(Vuex)

function getData() {
    return new Promise(resolve => {
        listSimpleDictDatas().then(suc => {
            console.log(suc);
            // 设置数据
            const dictDataMap = {}
            suc.data.data.forEach(dictData => {
                // 获得 dictType 层级
                const enumValueObj = dictDataMap[dictData.dictType]
                if (!enumValueObj) {
                    dictDataMap[dictData.dictType] = []
                }
                // 处理 dictValue 层级
                dictDataMap[dictData.dictType].push({
                    value: dictData.value,
                    label: dictData.label,
                    colorType: dictData.colorType,
                    cssClass: dictData.cssClass,
                })
            })
            // sessionStorage.setItem("DICT_DATA",JSON.stringify(dictDataMap))
            sessionStorage.setItemExpire("DICT_DATA", dictDataMap, 1000 * 60 * 30)  //设置30分钟过期时间
            resolve("hello")
        })
    })

}

function getBox() {
    return new Promise(resolve => {
        getInstrumentList().then(suc => {
            // 设置数据
            sessionStorage.setItemExpire("COMPANY_BOX", suc.data.data, 1000 * 30)  //设置30秒过期时间
            resolve("ok")
        })
    })

}

export default new Vuex.Store({
    modules: {
        inspection,
        maintenance,
        dailycheck,
        user,
        patrol,
        eva
    },
    state: {
        dictDatas: {},
        companyBox: [],
        scrollPosition: {

        },
        equTypeId: ''
    },
    getters: {
        getDictDatas(state) {
            return state.dictDatas
        },
        getCompanyBox(state) {
            return state.companyBox
        },
        getScrollPosition(state) {
            return state.scrollPosition
        },
        getEquTypeId(state){
            return state.equTypeId
        },
        getPermissions(state){
            return state.user.permissions
        }
    },
    mutations: {
        SET_DICT_DATAS: (state, dictDatas) => {
            state.dictDatas = dictDatas
        },
        SET_COMPANY_BOX: (state, companyBox) => {
            state.companyBox = companyBox
        },
        SET_SCROLL_POSITION: (state,data) => {
            state.scrollPosition[data.key] = data.value
        },
        SET_EQUTYPE_ID: (state,data) => {
            state.equTypeId = data
        }
    },
    actions: {
        loadDictDatas({commit}) {
            if (!sessionStorage.getItemExpire("DICT_DATA")) {
                getData().then(() => {
                    commit('SET_DICT_DATAS', sessionStorage.getItemExpire("DICT_DATA"))
                })
            } else {
                commit('SET_DICT_DATAS', sessionStorage.getItemExpire("DICT_DATA"))
            }
        },
        loadCompanyBox({commit}) {
            if (!sessionStorage.getItemExpire("COMPANY_BOX")) {
                getBox().then(() => {
                    commit('SET_COMPANY_BOX', sessionStorage.getItemExpire("COMPANY_BOX"))
                })
            } else {
                commit('SET_COMPANY_BOX', sessionStorage.getItemExpire("COMPANY_BOX"))
            }
        }
    },
})
